module.exports = __webpack_public_path__ + "static/assets/0c1b1afa3a33ee762f9a333017de3460.svg";